import type { SxProps, Theme } from "@mui/material";
import type { Reason } from "./types";
import { dialogClasses } from "@mui/material/Dialog";
import { dialogContentClasses } from "@mui/material/DialogContent";
import { dialogActionsClasses } from "@mui/material/DialogActions";
import { paperClasses } from "@mui/material/Paper";

export const isClosedByReason = (expectReason: Reason) => (_: unknown, reason?: Reason) => (
    Object.is(reason, expectReason)
);

export const withSx = (sx: SxProps<Theme>, {
    root,
    content,
    actions
}: {
        readonly [P in
        | 'root'
        | 'actions'
        | 'content'
        ]?: SxProps<Theme>;
    } = {}) => ({
        sx: {
            [`& .${dialogClasses.container} .${paperClasses.root}`]: {
                ...sx,
                ...root
            },
            [`& .${dialogContentClasses.root}`]: content,
            [`& .${dialogActionsClasses.root}`]: actions
        }
    });
